import { Badge, BadgeProps, Box, BoxProps, Flex, Tooltip } from '@chakra-ui/react';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';

import { IconButtonWithTooltip, Span } from 'shared-components';

interface ISidebarItem {
  label?: string;
  'data-selector'?: string;
  value?: React.ReactNode;
  valueColor?: 'error' | 'warning' | 'info' | 'success' | 'muted';
  valueBoxProps?: BoxProps;
  subValue?: React.ReactNode;
  tooltip?: React.ReactNode;
  isBadge?: boolean;
  badgeProps?: BadgeProps;
  editLabel?: string;
  onClickEdit?: () => void;
  disableEdit?: boolean;
}

export const SidebarItem = (props: ISidebarItem) => {
  const {
    label,
    value,
    valueColor,
    valueBoxProps,
    subValue,
    tooltip,
    isBadge,
    badgeProps,
    editLabel = 'Edit',
    onClickEdit,
    disableEdit = false,
    'data-selector': dataSelector,
  } = props;

  const getBadge = () => {
    if (isBadge) {
      return (
        <Badge {...badgeProps} maxWidth={'100%'}>
          <Span overflow={'hidden'} textOverflow={'ellipsis'}>
            {value}
          </Span>
        </Badge>
      );
    }
    return <span>{value}</span>;
  };

  return (
    <Flex data-selector={dataSelector} gap={1} pr={{ base: 0 }}>
      <Box
        width={{ base: '5.5rem', xl: '7rem', '2xl': '8.5rem', '3xl': '10rem' }}
        py={2}
        fontSize={'xs'}
        lineHeight={4}
        flexShrink={0}
        color={'muted'}
        fontWeight={'medium'}
      >
        {label}
      </Box>

      <Box
        flexGrow={1}
        py={isBadge ? 1 : 2}
        fontSize={'sm'}
        lineHeight={4}
        wordBreak={'break-word'}
        minWidth={0}
        color={valueColor}
        {...valueBoxProps}
      >
        <Tooltip hasArrow placement="top" label={tooltip}>
          {getBadge()}
        </Tooltip>

        {subValue && (
          <Box color={'muted'} fontSize={'xs'} mt={1}>
            {subValue}
          </Box>
        )}
      </Box>

      {onClickEdit && !disableEdit && (
        <Box flexShrink={0}>
          <IconButtonWithTooltip
            label={`${editLabel} ${label}`}
            onClick={onClickEdit}
            iconProps={{ icon: faEdit }}
            buttonProps={{ size: 'sm', variant: 'ghost' }}
          />
        </Box>
      )}
    </Flex>
  );
};
